import React, { useRef } from "react";

import styles from "../HeroSection/heroSection.module.css";
import useIsVisible from "../common/useIsVisibleRef";

import HumanStrategy from "../assests/Human-Machine.png";
import Automation from "../assests/automation.png";
import ParterShip from "../assests/Partnership.png";
import ConnectNow from "../common/connectNow";

// automation
import Effeciency from "../assests/Effeciency.svg";
import Emotion from "../assests/Emotion.svg";
import Accessibility from "../assests/Accesibility.svg";

import TrustedUser from "../assests/TrustedUser.svg";
import User from "../assests/User.svg";
import SatyamBhasin from "../assests/Satyam.jpeg";
import Quote from "../assests/quote.svg";

import Marquee from "../marquee/marquee";
import Solution from "./Solutions";
import SolutionOne from "./SolutionOne";
const ApartData = [
  {
    title: "Human - Machine Synergy",
    desc: "Harness the power of human intuition combined with advanced automation techniques to unlock new realms of wealth creation.",
    imgUrl: HumanStrategy,
  },
  {
    title: "Automation",
    desc: "From Indian equities to Forex , if it's electronically tradable, we automate it, providing you with unparalleled efficiency and agility.",
    imgUrl: Automation,
  },
  {
    title: "Trusted Partnerships",
    desc: "We collaborate with leading exchanges and brokers globally, ensuring the highest standards of security and reliability for your investments.",
    imgUrl: ParterShip,
  },
];

const TestimonialData = [
  {
    content: `Great! Compared to everything else I’ve ever used, this is the best technology.  used, this is the best .
`,
    imageUrl: TrustedUser,
    name: "Larsen Black",
    occupation: "Banker",
  },
  {
    content: `Great! Compared to everything else I’ve ever used, this is the best technology.  used, this is the best best technology.  used, this .`,
    imageUrl: TrustedUser,
    name: "Ravendra Prajapati",
    occupation: "Full Stack Developer",
  },
  {
    content: `Great! Compared to everything else I’ve ever used, this is the best technology.  used, this is the best .
`,
    imageUrl: TrustedUser,
    name: "Akshata Kenjale",
    occupation: "UI/UX Designer",
  },
  {
    content: `Great! Compared to everything else I’ve ever used, this is the best technology.  used, this is the best best technology.  used, this .`,
    imageUrl: TrustedUser,
    name: "Ravi",
    occupation: "Banker",
  },
  {
    content: `Great! Compared to everything else I’ve ever used, this is the best technology.  used, this is the best .`,
    imageUrl: TrustedUser,
    name: "Monu Singh ",
    occupation: "Banker",
  },
  {
    content: `Great! Compared to everything else I’ve ever used, this is the best technology.  used, this is the best best technology.  used, this .`,
    imageUrl: TrustedUser,
    name: "Larsen Black",
    occupation: "Banker",
  },
];
const style = {
  selectedDiv:
    "px-2 md:px-12 text-white font-sans font-bold text-sm md:text-[20px] md:leading-[46px] cursor-pointer border-b-2 border-[#01B0EA] md:pb-6 ",
  unSelectedDiv:
    "px-2 md:px-12 text-[#ffffff]/50 font-sans font-bold text-sm md:text-[20px] md:leading-[46px] cursor-pointer border-b-[1px] border-[#ffffff]/10 md:pb-6",
  tradingHeading: "text-xl md:text-2xl text-white font-sans font-bold",
  tradingDescription: "text-sm md:text-base text-[#ffffff]/50 font-poppins",
  flexDiv: "flex flex-row justify-center items-center",
};
const AllPart = () => {
  return (
    <div className="bg-[#1b1b1b]">
      {/* one Platform endless solutions*/}
      <div className="py-20 md:py-24" id="features">
        <div className="flex flex-col space-y-4 lg:space-y-2 justify-center items-center">
          {" "}
          <div
            className={`font-sans text-md md:text-xl font-semibold ${styles.text_gradient}`}
          >
            SOLUTIONS
          </div>
          <div
            className={`text-center font-extrabold text-white text-[18px] md:text-[38px] md:leading-[60px] font-sans`}
          >
            One Partner , Endless Solutions
          </div>
        </div>

        <Solution />
        <div className="flex flex-row justify-center mt-20">
          <ConnectNow />
        </div>

        <div className={`flex flex-col justify-center items-center mt-32 }`}>
          <div className="flex flex-col space-y-4 lg:space-y-2 justify-center items-center">
            <div
              className={`font-sans text-md md:text-xl font-semibold ${styles.text_gradient}`}
            >
              SUPPORTED BROKERS
            </div>
            <div className="text-center font-extrabold text-white text-[18px]  md:text-[38px] md:leading-[60px] font-sans">
              If E-Tradable, we've got it covered.
            </div>
          </div>
          <SolutionOne />
        </div>

        <div className="flex flex-row justify-center mt-20">
          <ConnectNow />
        </div>
      </div>
      {/* what sets apart*/}
      <div className="py-20 md:py-24" id="why-sbadvisory">
        <div className="flex flex-col space-y-4 lg:space-y-2 justify-center items-center ">
          {" "}
          <div
            className={`font-sans text-md md:text-xl font-semibold ${styles.text_gradient}`}
          >
            WHY US
          </div>
          <div className="font-extrabold text-white text-[18px]  md:text-[38px] md:leading-[60px] font-sans">
            What Sets us Apart ?
          </div>
        </div>
        <div
          className={` grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-10 md:gap-y-10 lg:gap-y-0 md:gap-x-10 px-8 md:px-[70px] lg:px-32  mt-8`}
        >
          {ApartData.map((ele, i) => {
            return (
              <div key={i}>
                <div  className={`w-full flex flex-col mt-3 md:mt-0  `}>
                  <div className="overflow-hidden">
                    <img
                      src={ele.imgUrl}
                      className="w-full rounded-xl h-[250px]  "
                      alt={ele.title}
                    />
                  </div>
                  <div className="w-full text-left  font-sans font-bold text-[18px] md:text-[22px] leading-[50px] text-white mt-4">
                    {ele.title}
                  </div>
                  <div className="w-full text-left  text-sm md:text-[16px] leading-[26px] text-[#ffffff]/50 font-poppins mt-2">
                    {ele.desc}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex flex-row justify-center mt-20">
          <ConnectNow />
        </div>
      </div>

      {/* trusred by*/}
      <div className={`py-20 md:py-24  `} id="testimonals">
        <div className="px-6 md:px-48 space-y-4 lg:space-y-2 flex flex-col justify-center items-center lg:justify-start lg:items-start ">
          <div
            className={`font-sans text-md md:text-xl font-semibold ${styles.text_gradient}`}
          >
            CLIENT TESTIMONIALS
          </div>
          <div className="font-extrabold text-white text-[18px]  md:text-[38px] md:leading-[60px] font-sans">
            Trusted by
          </div>
        </div>
        <Marquee testimonialData={TestimonialData} />
        <div className="flex flex-row justify-center mt-20 md:mt-28">
          <ConnectNow />
        </div>
      </div>

      {/* Automation*/}
      <div className="py-20 md:py-24" id="automation">
        <div className="flex flex-col space-y-4 lg:space-y-2 justify-center items-center">
          {" "}
          <div
            className={`font-sans text-md md:text-xl font-semibold ${styles.text_gradient}`}
          >
            BENEFITS
          </div>
          <div className="font-extrabold text-white text-[18px]  md:text-[38px] md:leading-[60px] font-sans">
            Automate to Elevate !
          </div>
        </div>

        <div
          className={`mt-20 flex flex-col space-y-10 md:space-y-0 md:flex-row justify-between items-center px-4 md:px-10 lg:px-48`}
        >
          <div className="relative md:w-[30%] px-10 md:px-1 flex flex-col space-y-4  md:h-[350px] ">
            <div className="flex items-center justify-center lg:justify-start ">
              <img
                className=" w-[100px]  transition duration-150 ease-linear"
                src={Effeciency}
                alt="Effecifiency"
              />
              <div className="absolute w-[0%] md:w-[60%] h-[1px] bg-[#ffffff]/10 lg:-right-[20px]"></div>
            </div>
            <div className="flex flex-1 flex-col space-y-4  ">
              <div
                className={` w-full text-base  md:text-[22px] text-center md:leading-[30px] lg:text-left lg:leading-[50px] ${style.tradingHeading} `}
              >
                Efficiency & Speed
              </div>
              <div
                className={` w-full  text-xs md:text-[16px] leading-[26px] text-center lg:text-left  ${style.tradingDescription}`}
              >
                Automated trading executes orders at lightning speed, seizing
                opportunities in real-time with precision.
              </div>
            </div>
          </div>

          <div className="relative  md:w-[30%] px-10 md:px-1 flex flex-col space-y-4  md:h-[350px] ">
            <div className="flex  items-center justify-center lg:justify-start ">
              <img
                className=" w-[100px] transition duration-150 ease-linear"
                src={Emotion}
                alt="Speed"
              />
              <div className="absolute w-[0%] md:w-[60%] h-[1px] bg-[#ffffff]/10  lg:-right-[20px]"></div>
            </div>

            <div className="flex flex-1 flex-col space-y-4 ">
              <div
                className={`w-full text-base  md:text-[22px] text-center md:leading-[30px] lg:text-left lg:leading-[50px] ${style.tradingHeading} `}
              >
                Objective Trading
              </div>
              <div
                className={`text-xs md:text-[16px] leading-[26px]  md:w-[95%] text-center lg:text-left ${style.tradingDescription}`}
              >
                Remove human biases and emotions from the equation, ensuring
                consistent and disciplined trading decisions.
              </div>
            </div>
          </div>

          <div className="md:w-[30%] px-10 md:px-1 flex flex-col space-y-4   md:h-[350px] ">
            <div className="flex items-center justify-center lg:justify-start ">
              <img
                className=" w-[100px]  transition duration-150 ease-linear"
                src={Accessibility}
                alt="Accessibility}"
              />
            </div>
            <div className="flex flex-1  flex-col space-y-4 ">
              <div
                className={`w-full text-base  md:text-[22px] text-center md:leading-[30px] lg:text-left lg:leading-[50px] ${style.tradingHeading} `}
              >
                Always-On Trading
              </div>
              <div
                className={`text-xs md:text-[16px] leading-[26px]  md:w-[90%] text-center lg:text-left ${style.tradingDescription}`}
              >
                Trade non-stop, across time zones with our automated systems.
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-center mt-24">
          <ConnectNow />
        </div>
      </div>

      {/* build your future */}
      <div className={`  py-8 md:py-24 flex flex-row justify-center `}>
        <div
          className={`w-[90%] md:w-[70%] ${styles.linearGradient} rounded-[20px] shadow-lg border border-[#ffffff]/10`}
        >
          <div className="relative flex flex-col lg:flex-row ">
            <div className="w-full h-[450px] lg:h-auto lg:w-[30%] rounded-[20px]    overflow-hidden">
              <img
                src={SatyamBhasin}
                alt="User"
                className="w-full rounded-[20px]  lg:rounded-none"
              />
            </div>
            <div className="flex flex-col  items-center justify-center  w-full lg:w-[70%] px-4 py-10 md:px-12 md:py-10">
              <div>

            
            <h1 className="text-2xl md:text-5xl font-bold text-white tracking-normal leading-[40px] md:leading-[60px] max-w-[500px]">
              Satyam Bhasin is the CEO of SbAdvisory
            </h1>
              </div>
              <div className="absolute bottom-6 right-8 items-center mt-8">
                <div>
                  <img
                    src={Quote}
                    alt="Quote"
                    className="w-[50px] md:w-[80px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllPart;
